<template>
  <div class="patrol-record-wrap section-main__warp">
    <ioc-table
      ref="crud"
      :data="historyList"
      :option="option"
      :page="page"
      @search-change="searchHistory"
      @search-reset="clearHistory"
      @size-change="sizeChange"
      @current-change="pageChange"
    >
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/elePatrol-patrolrecord:export'"
          :loading="exportDisabled"
          @click="exportFile"
          icon="el-icon-download"
          >{{ exportDisabled ? "正在导出..." : "导出" }}</el-button
        >
      </template>
      <template slot="search_taskName" slot-scope="scope">
        <el-select
          v-model="scope.row.taskName"
          @change="selectChange"
          filterable
        >
          <el-option
            v-for="item in taskOptions"
            :key="item.patrolPlanCode"
            :label="item.planName"
            :value="item.planName"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="search_securityWorkGroupNames" slot-scope="scope">
        <el-cascader
          class="cascader-panel"
          v-model="scope.row.securityWorkGroupNames"
          :options="groupListOptions"
          :props="{
            expandTrigger: 'hover',
            multiple: true,
            label: 'name',
            value: 'id',
          }"
          collapse-tags
          :show-all-levels="false"
          @change="handleChange"
          @getCheckedNodes="getCheckedNodes"
        ></el-cascader>
      </template>
      <template slot="search_patrolDate">
        <div>
          <el-date-picker
            type="datetime"
            placeholder="请选择开始时间"
            v-model="taskStartTime"
            default-time="00:00:00"
            style="width: 182px"
          ></el-date-picker>
          <span style="padding: 0 5px">至</span>
          <el-date-picker
            type="datetime"
            placeholder="请选择结束时间"
            v-model="taskEndTime"
            default-time="23:59:59"
            style="width: 182px"
          ></el-date-picker>
        </div>
        <!-- <el-date-picker
          @change="searchHistory"
          v-model="scope.row.patrolDate"
          type="daterange"
          editable
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker> -->
      </template>
      <template slot="taskStatus" slot-scope="scope">
        <span
          v-if="scope.row.taskStatus === 1"
          style="color: yellow; cursor: pointer"
          @click="openRecDetail(scope.row)"
          >{{ taskStatusType(scope.row.taskStatus) }}</span
        >
        <span
          v-if="scope.row.taskStatus === 2"
          style="color: #00e8bb; cursor: pointer"
          @click="openRecDetail(scope.row)"
          >{{ taskStatusType(scope.row.taskStatus) }}</span
        >
        <span
          v-if="scope.row.taskStatus === 3"
          style="color: #9b9b9b; cursor: pointer"
          @click="openRecDetail(scope.row)"
          >{{ taskStatusType(scope.row.taskStatus) }}</span
        >
        <span
          v-if="scope.row.taskStatus === 4"
          style="color: red; cursor: pointer"
          @click="openRecDetail(scope.row)"
          >{{ taskStatusType(scope.row.taskStatus) }}</span
        >
      </template>
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="openRecDetail(scope.row)"
          >
          </el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <patrolDetail ref="refPatrolDetail" />
  </div>
</template>
<script>
import { formatTimeToStr } from "../filter/dateUtils";
import utils from "@src/common/utils";
import { parseTime } from "@src/common/filters";
import { Dates, Bus, Dic, Cache } from "$utils";
import { api } from "../api";
import tableOption from "../const/table";
import patrolDetail from "../components/patrolDetail";
export default {
  components: {
    patrolDetail,
  },
  filters: {
    formatDate: function (time) {
      if (time !== null && time !== "") {
        return formatTimeToStr(new Date(time));
      } else {
        return "";
      }
    },
  },

  data() {
    return {
      groupListOptions: [], //隶属中队
      exportDisabled: false,
      securityWorkGroupCodeList: [], //中队传入字段
      taskOptions: [], //任务名称
      account: {},
      option: tableOption(this),
      Bus,
      total: 0,
      taskStartTime: "",
      taskEndTime: "",
      page: {
        pageNum: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      form: {
        timeRange: "",
        realStartTime: "",
        realEndTime: "",
        taskName: "",
        taskStatus: "",
      },
      historyList: [],
      searchParams: {
        taskName: "",
        taskStatus: "",
        executorNames: "",
        securityWorkGroupNames: "",
        taskStartTime: "",
        taskEndTime: "",
      },
      loginAccount: Cache.get("CACHE_USER_INFO").account,
    };
  },
  computed: {},
  created() {
    this.getHistory();
    this.querySecurityWorkGroup();
    this.queryElectronicPatrolPlanNameList();
  },
  methods: {
    queryElectronicPatrolPlanNameList() {
      this.$nextTick(() => {
        this.$fetch(api.patrolTask.queryElectronicPatrolPlanNameList, {
          planName: this.$refs.crud.searchForm.taskName,
        }).then((res) => {
          if (res.success) {
            this.taskOptions = res.returnObj;
          }
        });
      });
    },
    selectChange(data) {
      this.searchParams.taskName = data;
    },
    handleChange(node) {
      this.securityWorkGroupCodeList = [];
      if (node) {
        node.forEach((item) => {
          this.securityWorkGroupCodeList =
            this.securityWorkGroupCodeList.concat(item);
        });
      }
    },
    getCheckedNodes(node) {
      console.log(node, "0000000000000000");
    },
    querySecurityWorkGroup() {
      this.$fetch(api.patrolTask.querySecurityWorkGroup).then((res) => {
        if (res.success) {
          this.groupListOptions = this.menusDataPro(res.returnObj);
          // console.log(res, this.groupListOptions);
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.securityWorkGroupCode;
          entity.name = item.securityWorkGroupName;
          entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren;
          if (
            item.securityWorkGroupChildren &&
            item.securityWorkGroupChildren.length > 0
          ) {
            entity.children = self.menusDataPro(item.securityWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    taskStatusType(item) {
      if (item == 1) {
        return "待巡逻";
      } else if (item == 2) {
        return "巡逻中";
      } else if (item == 3) {
        return "已完成";
      } else if (item == 4) {
        return "已超时";
      }
    },
    //页面初始化数据
    /**
     * 查询巡更记录 getHistory
     * @param  taskName       巡更记录名称
     * @param  pageNum        页码(必填)
     * @param  pageSize       页大小(必填)
     * @param  taskStartTime  任务开始时间:如 yyyy-MM-dd HH:mm:ss
     * @param  taskEndTime    任务结束时间:如 yyyy-MM-dd HH:mm:ss
     * @param  taskStatus     1.待巡逻 2.巡逻中 3.已完成 4.已超时
     * */
    getHistory() {
      const self = this;
      let params = {
        taskName: this.searchParams.taskName,
        taskStartTime: this.searchParams.taskStartTime,
        taskEndTime: this.searchParams.taskEndTime,
        taskStatus: this.searchParams.taskStatus,
        executorName: this.searchParams.executorNames,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      if (
        this.securityWorkGroupCodeList &&
        this.securityWorkGroupCodeList.length > 0
      ) {
        params.securityWorkGroupCodeList = this.securityWorkGroupCodeList;
      }

      const loading = self.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)",
      });
      self
        .$fetch(api.patrolTask.queryPatrolRecordList, params)
        .then((response) => {
            loading.close();
          if (response.success) {
            self.historyList =
              (response.returnObj && response.returnObj.list) || [];
            self.page.total =
              (response.returnObj && response.returnObj.total) || 0;
            // console.log(self.historyList);
          } else {
            this.$message.error(response.msgContent);
          }
        });
    },
    // 查看报告详情
    openRecDetail(row) {
      this.$refs["refPatrolDetail"].handleOpenPanel(row);
      // this.$router.push({
      //   name: "PatrolRecordDetail",
      //   params: {
      //     patrolTaskCode: row.patrolTaskCode,
      //   },
      // });
    },
    searchHistory(param) {
      this.searchParams = Object.assign({}, param);
      this.taskStartTime
        ? (this.searchParams.taskStartTime = parseTime(this.taskStartTime))
        : "";
      this.taskEndTime
        ? (this.searchParams.taskEndTime = parseTime(this.taskEndTime))
        : "";
      this.getHistory();
    },
    clearHistory() {
      this.searchParams = {};
      this.taskStartTime = "";
      this.taskEndTime = "";
      this.securityWorkGroupCodeList = [];
      this.getHistory();
    },
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getHistory();
    },
    pageChange(val) {
      this.page.pageNum = val;
      this.getHistory();
    },
    /**
     * 导出巡更记录列表
     * @param  taskName       巡更记录名称
     * @param  taskStartTime  任务开始时间:如 yyyy-MM-dd HH:mm:ss
     * @param  taskEndTime    任务结束时间:如 yyyy-MM-dd HH:mm:ss
     * @param  taskStatus     1.待巡逻 2.巡逻中 3.已完成 4.已超时
     * */
    exportFile() {
      if (!this.historyList.length) {
        this.$message.warning("暂无数据可以导出");
        return;
      }
      var start_time = "";
      var end_time = "";
      if (this.taskStartTime && this.taskEndTime) {
        start_time = this.taskStartTime;
        end_time = this.taskEndTime;
        let startTime = new Date(start_time).getTime();
        let endTime = new Date(end_time).getTime();
        if (endTime - startTime > 30 * 24 * 60 * 60 * 1000) {
          this.$message.warning("导出数据时间跨度不可超过30天");
          return;
        }
        console.log(
          Dates.format(new Date(start_time).getTime(), "yyyy/MM/dd 00:00:00"),
          endTime
        );
        this.fetchDownLoadFile(
          Dates.format(new Date(start_time).getTime(), "yyyy/MM/dd 00:00:00"),
          Dates.format(new Date(end_time).getTime(), "yyyy/MM/dd 23:59:59")
        );
      } else if (!this.taskStartTime && !this.taskEndTime) {
        this.$confirm("未输入时间，默认导出最近7天数据", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        }).then(() => {
          start_time = Dates.format(
            new Date(Date.now() - 7 * 24 * 3600 * 1000),
            "yyyy/MM/dd 00:00:00"
          );
          end_time = Dates.format(new Date(), "yyyy/MM/dd 23:59:59");
          this.fetchDownLoadFile(start_time, end_time);
        });
      } else if (!this.taskStartTime) {
        this.$confirm("未输入开始时间，默认导出结束前7天数据", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        }).then(() => {
          end_time = Dates.format(this.taskEndTime, "yyyy/MM/dd 23:59:59");
          start_time = Dates.format(
            new Date(this.taskEndTime.getTime() - 7 * 24 * 3600 * 1000),
            "yyyy/MM/dd 00:00:00"
          );
          this.fetchDownLoadFile(start_time, end_time);
        });
      } else if (!this.taskEndTime) {
        this.$confirm("未输入结束时间，默认导出开始时间后7天数据", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning",
        }).then(() => {
          start_time = parseTime(this.taskStartTime);
          end_time = Dates.format(
            new Date(this.taskStartTime.getTime() + 7 * 24 * 3600 * 1000),
            "yyyy/MM/dd 23:59:59"
          );
          this.fetchDownLoadFile(start_time, end_time);
          // console.log(
          //   this.taskStartTime,
          //   end_time,
          //   Dates.format(end_time, "yyyy/MM/dd 23:59:59"),
          //   Date(new Date(start_time)),
          //   parseTime(start_time + 7 * 24 * 3600 * 1000),
          //   "====aaa3333333"
          // );
        });
      }
    },
    // 导出xlsx文件
    fetchDownLoadFile(start_time, end_time) {
      // 兼容IE
      let params = {
        taskStartTime: start_time.replace(/\//g, "-"),
        taskEndTime: end_time.replace(/\//g, "-"),
        taskName: this.searchParams.taskName,
        taskStatus: this.searchParams.taskStatus,
        executorName: this.searchParams.executorNames,
        securityWorkGroupName: this.searchParams.securityWorkGroupNames,
      };
      this.exportDisabled = true;
      this.$fetchDownLoad(api.patrolTask.exportPatrolTask, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          //  console.log('date',window.DATE)
          const fileName =
            "电子巡更记录" +
            Dates.format(Date.now(), "yyyyMMddHHmmssms") +
            ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
        this.exportDisabled = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ioc-detail__box {
  text-align: left;
}
.patrol-record-wrap {
  // padding: 10px;
  border-bottom: 1px solid #304367;
  flex: 1;
  .el-form-item {
    margin-right: 50px;
    margin-left: 10px;
    // button{
    //   padding: 7px 30px
    // }
  }
  .el-pagination {
    text-align: center;
  }
  .numsPage {
    text-align: center;
    ul {
      display: flex;
      justify-content: center;
      li {
        width: 20px;
        cursor: pointer;
      }
    }
  }
  .operation {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.patrol-record-wrap .el-carousel {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  .el-carousel__indicators {
    display: none;
  }
}
</style>
